import {SCHOOL_Id,USER_INFO} from '@/js/utils/constant.js'
import api from "@/js/API/index.js";
import EventBus from '@/js/EventBus'
const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
let userInfoStr=localStorage.getItem(USER_INFO)
const state = () => ({
  gradeInfo: {
    gradeGroupId: null,
    gradeId: null
  },
  teachingMaterial: {}, //教材信息
  currentVideoIndex: 0, //推荐页当前播放视频
  userInfo: userInfoStr?JSON.parse(userInfoStr):{},
  clientId:  501109,
  //用户在机构下的相关信息
  schoolId: localStorage.getItem(SCHOOL_Id),
  deviceId:""
});

// getters
const getters = {
  orgInfo:state=>{
    if(state.schoolId&&state.userInfo){
      const info = state.userInfo.orgList.find(item=>item.id==state.schoolId)
      return info || {}
    }else{
      return {}
    }
  },
  orgList:state=>{
    if(state.schoolId&&state.userInfo){
      return state.userInfo.orgList
    }else return []
  }
};

// actions
const actions = {
  logOut(context){
    context.commit('updateSchoolId','')
    context.commit('updateUserInfo',{})
    EventBus.$emit('logOutEvent')
  },
  changeOrg(context,value){
    const token = localStorage.getItem('token')
    if (!token) {
      localStorage.removeItem(USER_INFO)
      localStorage.removeItem('token')
      localStorage.removeItem(SCHOOL_Id)
      EventBus.$emit('logOutEvent')
      return
    }
    api.updateOrg({orgId: value}).then((result) => {
      if (result.code == 200) {
        context.commit('updateSchoolId',value)
        localStorage.setItem(SCHOOL_Id, value);
        api.userDetail().then(res=>{
          const {data:userinfodetail}=res
          //同产品沟通，端内外的分享页登录不弹选择机构窗
          localStorage.setItem(USER_INFO,JSON.stringify(userinfodetail))
          context.commit('updateUserInfo',userinfodetail)
          EventBus.$emit('updateUserInfo', userinfodetail)
        })
      }
    })
  }

};

// mutations
const mutations = {
  updateGradeInfo(state, gradeInfo) {
    // console.log(gradeInfo)
    state.gradeInfo.gradeGroupId = gradeInfo.gradeGroupId;
    state.gradeInfo.gradeId = gradeInfo.gradeId;
  },
  updateTeachingMaterial(state, teachingMaterial) {
    state.teachingMaterial = teachingMaterial;
  },
  updateVideoIndex(state, index) {
    state.currentVideoIndex = index;
  },
  updateSchoolId(state,schoolId){
    state.schoolId=schoolId
  },
  updateDeviceId(state,deviceId){
    state.deviceId=deviceId
  },
  updateUserInfo(state,userInfo){
    state.userInfo=userInfo
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/User.js